import { queries } from '../lib/supabase/queries';

export const projectsService = {
  async getAll() {
    return queries.projects.getAll();
  },

  async getPublished() {
    return queries.projects.getPublished();
  },

  async create(project) {
    return queries.projects.create(project);
  },

  async update(id, updates) {
    return queries.projects.update(id, updates);
  },

  async delete(id) {
    return queries.projects.delete(id);
  },

  async addImage(projectId, imageUrl, storagePath = '', altText = '', sortOrder = 0) {
    return queries.projects.addImage(projectId, imageUrl, storagePath, altText, sortOrder);
  },

  async deleteImage(imageId, storagePath = '') {
    return queries.projects.deleteImage(imageId, storagePath);
  },
};

export default projectsService;
